const UserModel = Backbone.Model.extend({
  defaults: {
    fullname: '',
    email: '',
    login: '',
    profile: 'Team Member',
    preserve_hierarchy: 1,
    color: '#555555',
    week_start_day: null,
  },

  initialize(userData, options) {
    if (window.appConfig.setDefaultToClient) {
      this.defaults.profile = 'Client';
    }
    this.options = options;

    if (this.options?.useUserPreferencesAPI) {
      this.updateApiMethod = Sendible.Connect.updateUserPreferences;
    } else {
      this.updateApiMethod = Sendible.Connect.updateUser;
    }
  },

  addTrialTimeToUser(daysToAdd, callback, errorCallback) {
    // Sendible.Connect.saveTrialSettingsForWhiteLabel
    const params = {
      days: daysToAdd || 0,
      trial_user_id: this.get('id'),
    };

    Sendible.Connect.addTimeToTrialUser(window.appConfig.applicationId, params, callback, errorCallback);
  },

  upgradeTrialUserToPayingUser(callback, errorCallback) {
    const params = {
      trial_user_id: this.get('id'),
    };

    Sendible.Connect.upgradeTrialUser(window.appConfig.applicationId, params, callback, errorCallback);
  },

  sync(method, model, options) {
    let user;
    const modelAttributes = model.toJSON();

    if (method === 'read') {
      user = {};

      if (modelAttributes.id) {
        user.user_id = modelAttributes.id;
      }

      Sendible.Connect.GetUserByUserId(
        window.appConfig.applicationId,
        $username,
        $password,
        user,
        (result) => { // onSuccess
          if (options.success != null) {
            options.success(result);
          }
        },
        (result) => { // onError
          if (options.error != null) {
            options.error(model, result.error);
          }
        },
      );
    }

    if (method == 'create' || method == 'update') {
      user = {
        fullname: modelAttributes.fullname,
        email: modelAttributes.email,
        login: modelAttributes.login,
        profile: modelAttributes.profile,
      };

      if (typeof modelAttributes.password !== 'undefined') {
        user.password = modelAttributes.password;
      }

      if (typeof modelAttributes.is_active !== 'undefined') {
        user.is_active = modelAttributes.is_active;
      }

      if (typeof modelAttributes.marketing !== 'undefined') {
        user.marketing = modelAttributes.marketing;
      }

      if (typeof modelAttributes.valid_ips !== 'undefined') {
        user.valid_ips = modelAttributes.valid_ips;
      }

      if (typeof modelAttributes.mobile !== 'undefined') {
        user.mobile = modelAttributes.mobile;
      }

      if (typeof modelAttributes.timezone !== 'undefined') {
        user.timezone = modelAttributes.timezone;
      }

      if (modelAttributes.timezone_name) {
        user.timezone_name = modelAttributes.timezone_name;
      }

      if (typeof modelAttributes.clock_format !== 'undefined') {
        user.clock_format = modelAttributes.clock_format;
      }

      if (typeof modelAttributes.url_shortener !== 'undefined') {
        user.url_shortener = modelAttributes.url_shortener;
      }

      if (typeof modelAttributes.url_shortener_login !== 'undefined') {
        user.url_shortener_login = modelAttributes.url_shortener_login;
      }

      if (typeof modelAttributes.url_shortener_key !== 'undefined') {
        user.url_shortener_key = modelAttributes.url_shortener_key;
      }

      if (typeof modelAttributes.bitly_pro_domain !== 'undefined') {
        user.bitly_pro_domain = modelAttributes.bitly_pro_domain;
      }

      if (typeof modelAttributes.image_shortener !== 'undefined') {
        user.image_shortener = modelAttributes.image_shortener;
      }

      if (typeof modelAttributes.preference !== 'undefined') {
        user.preference = modelAttributes.preference;
      }

      if (typeof modelAttributes.is_paused !== 'undefined') {
        user.is_paused = modelAttributes.is_paused;
      }

      if (modelAttributes.parent_user_id) {
        user.managed_by_id = modelAttributes.parent_user_id;
      }

      if (typeof modelAttributes.managed_by_id !== 'undefined') {
        user.managed_by_id = modelAttributes.managed_by_id;
      }

      if (typeof modelAttributes.manager_of !== 'undefined') {
        user.manager_of = modelAttributes.manager_of;
      }

      if (typeof modelAttributes.preserve_hierarchy !== 'undefined') {
        user.preserve_hierarchy = modelAttributes.preserve_hierarchy;
      }

      if (typeof modelAttributes.approval_from_ids !== 'undefined') {
        user.approval_from_ids = modelAttributes.approval_from_ids;
      }

      if (modelAttributes.permission_profile_id) {
        user.permission_profile_id = modelAttributes.permission_profile_id;
      } else if (!!modelAttributes.permission_profile && !!modelAttributes.permission_profile.id) {
        user.permission_profile_id = modelAttributes.permission_profile.id;
      }

      if (typeof modelAttributes.photo_id !== 'undefined') {
        user.photo_id = modelAttributes.photo_id;
      }

      if (typeof modelAttributes.id !== 'undefined') {
        user.user_id = modelAttributes.id;
      }

      if (typeof modelAttributes.language !== 'undefined') {
        user.language = modelAttributes.language;
      }

      if (typeof modelAttributes.color !== 'undefined') {
        user.color = modelAttributes.color;
      }

      if (typeof modelAttributes.confirmPassword !== 'undefined') {
        user.confirm_password = modelAttributes.confirmPassword;
      }

      if (typeof modelAttributes.email_to_notify !== 'undefined') {
        user.email_to_notify = modelAttributes.email_to_notify;
      }

      if (typeof modelAttributes.default_filter !== 'undefined') {
        user.default_filter = modelAttributes.default_filter;
      }

      if (typeof modelAttributes.phonenumber !== 'undefined') {
        user.phonenumber = modelAttributes.phonenumber;
      }

      if (typeof modelAttributes.wl_apikey !== 'undefined') {
        user.wl_apikey = modelAttributes.wl_apikey;
      }

      if (typeof modelAttributes.recaptcha !== 'undefined') {
        user.recaptcha = modelAttributes.recaptcha;
      }

      if (typeof modelAttributes.user_week_start_day !== 'undefined') {
        user.week_start_day = modelAttributes.user_week_start_day;
      }

      if (method == 'create' && options.createTrialUser) {
        // trial users are Client by profile.
        user.profile = 'Client';

        return Sendible.Connect.createNewTrialUser(
          window.appConfig.applicationId,
          user,
          (result) => { // onSuccess
            if (options.success != null) {
              options.success(result);
            }
          },
          (result) => { // onError
            if (options.error != null) {
              options.error(result);
            }
          },
        );
      } if (method == 'create') {
        return Sendible.Connect.createUser(
          window.appConfig.applicationId,
          $username,
          $password,
          user,
          (result) => { // onSuccess
            if (options.success != null) {
              options.success(result);
            }
          },
          (result) => { // onError
            if (options.error != null) {
              options.error(result);
            }
          },
        );
      } if (method == 'update') {
        return this.updateApiMethod(
          window.appConfig.applicationId,
          $username,
          $password,
          user,
          (result) => { // onSuccess
            if (options.success != null) {
              options.success(result);
            }
          },
          (result) => { // onError
            if (options.error != null) {
              options.error(result);
            }
          },
        );
      }
    }

    if (method == 'delete') {
      Sendible.Connect.deleteUser(window.appConfig.applicationId, $username, $password, modelAttributes.id, modelAttributes.api_key, (result) => {
        options.success(result);
      });
    }
  },

  setPermissionData(inputValue) {
    this.get('permission_profile').profile_name = inputValue;
    this.set('permissionName', inputValue);
  },

});

export default UserModel;
